<script>
import { mixin as clickaway } from 'vue-clickaway';
import {
  authComputed,
  campaignComputed,
  campaignMethods,
} from '@state/helpers';

export default {
  components: {},
  props: {
    isSending: {
      type: Boolean,
      required: false,
    },
  },
  mixins: [clickaway],
  data() {
    return {
      showCampaignDropdown: false,
    };
  },
  computed: {
    ...authComputed,
    ...campaignComputed,
    disableSendBtn() {
      return this.isSending || !this.recipientCount;
    },
  },
  mounted() {},
  methods: {
    ...campaignMethods,
    sendCampaign() {
      if (!this.disableSendBtn) {
        this.$emit('send-campaign');
      }
    },
    selectCampaign(campaign) {
      this.showCampaignDropdown = false;
      this.setSelectedCampaign(campaign);
    },
    toggleCampaignDropdown() {
      this.showCampaignDropdown = !this.showCampaignDropdown;
    },
  },
};
</script>

<template>
  <div class="prospect-msg-composer-header">
    <div>
      <span class="composer-campaign-title">{{ selectedCampaign.name }}</span>
      <span class="composer-campaign-selector" @click="toggleCampaignDropdown">
        Change Campaign
        <BaseIcon :name="showCampaignDropdown ? 'caret-up' : 'caret-down'" />
      </span>
      <div
        class="composer-campaign-opts"
        v-if="showCampaignDropdown"
        v-on-clickaway="toggleCampaignDropdown"
      >
        <ul>
          <li
            v-for="(campaign, i) in campaigns"
            :key="i"
            @click="selectCampaign(campaign)"
            >{{ campaign.order }}: {{ campaign.name }}</li
          >
        </ul>
      </div>
    </div>

    <BaseButton
      type="button"
      class="btn-primary btn-round"
      :disabled="disableSendBtn"
      @click="sendCampaign"
    >
      <BaseIcon v-if="isSending" name="sync" spin />
      <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-mail'" v-if="!isSending" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M23.627 6.258L8.22 15.123c-.597.332-.531 1.195.067 1.428l3.552 1.494 9.53-8.4c.166-.166.431.066.265.265l-7.969 9.729v2.69a.786.786 0 001.395.53l2.125-2.59 4.117 1.76c.465.2 1.03-.1 1.096-.63l2.39-14.344c.133-.664-.597-1.13-1.162-.797z" fill="#fff"/></svg>
      Send Campaign ({{ recipientCount }})
    </BaseButton>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.prospect-msg-composer-header {
  background-color: $color-light-gray-twenty-one;
  display: flex;
  justify-content: space-between;
  padding: 1.4rem 1.6rem;
  position: fixed;
  width: 100%;

  .composer-campaign-title,
  .composer-campaign-selector {
    color: black;
    font-size: 1.7rem;
    letter-spacing: -0.233333px;
    line-height: 2.8rem;
  }

  .composer-campaign-title {
    font-weight: 300;
    margin-right: 2.3rem;
  }

  .composer-campaign-selector {
    font-weight: 800;

    &:hover {
      cursor: pointer;
    }
  }

  .composer-campaign-opts {
    background: white;
    border-radius: $base-border-radius-md;
    box-shadow: 0 0 0.4rem rgba($color-black-wo-rgb, 0.15);
    left: 22rem;
    padding: 1.8rem 0;
    position: absolute;
    top: 4.8rem;
    width: auto;
    z-index: 1;

    &:hover {
      cursor: default;
    }

    li {
      color: black;
      flex-grow: 0;
      font-size: 1.4rem;
      font-weight: 300;
      letter-spacing: -0.257143px;
      line-height: 2.4rem;
      margin: 0.6rem 0;
      order: 1;
      padding: 0 1.8rem;

      &:hover {
        background-color: $color-primary;
        color: white;
        cursor: pointer;
      }
    }
  }

  .btn-primary,
  .btn-primary:active,
  .btn-primary:focus,
  .btn-primary:not(:disabled):not(.disabled):active {
    padding-left: 4rem;
    position: relative;

    .icon-mail {
      left: 1.3rem;
      position: absolute;
      top: 0.2rem;
      width: 2.2rem;
    }

    .fa-spin {
      height: 1.2rem;
      left: 2rem;
      position: absolute;
    }
  }

  .btn-primary.button:disabled:hover {
    background: $color-primary-five;
  }
}
</style>
